module.exports = __webpack_public_path__ + "img/架构图.12b63239.png";